export const ScoreLabel = {
  POSITIVE: 0,
  NEUTRAL: 1,
  NEGATIVE: 2,
};
